import { RSAA } from 'redux-api-middleware';
import { getToken } from '../config/adalConfig';

export default function() {
  return function(next) {
    return function(action) {
      const callApi = action[RSAA];
      if (callApi) {
        const token = getToken()
          ? getToken()
          : localStorage.getItem('jwt_token')
            ? localStorage.getItem('jwt_token')
            : null;
        if (!callApi.headers) {
          callApi.headers =   Object.assign({}, { 'Content-Type': 'application/json' });
        }
        callApi.headers = Object.assign({}, callApi.headers, {
          Authorization: token ? `Bearer ${token}` : '',
        });
      }
      return next(action);
    };
  };
}



// WEBPACK FOOTER //
// ./src/store/api-auth-injector.js